// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import vueResource from 'vue-resource'
import ElementUI from 'element-ui'
import store from './store'
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/global.css'
import 'iview/dist/styles/iview.css';    // 使用 CSS
import utils from './util/index'
import signout from './util/signout.js'
import utilsnew from './util/utils.js'
import img from './util/img'
import iView from 'iview';
import '@/components/index'
Vue.prototype.$images = img
Vue.use(iView);
Vue.use(utilsnew)


import VueAMap from 'vue-amap'
Vue.use(VueAMap)
VueAMap.initAMapApiLoader({
  key: '3aefd45dd373ddbbd786b7b162aa6e0e',
  plugin: ['AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PlaceSearch', 'AMap.Geolocation', 'AMap.Geocoder'],
  v: '1.4.4',
  uiVersion: '1.0'
})

// 引用axios
import api from './api/index'
import apiurl from './api/api'
// import echarts from 'echarts'
let echarts = require('echarts')
import html2canvas from 'html2canvas'
// Vue.prototype.$echarts = echarts
Vue.prototype.$https = api
Vue.prototype.$api = apiurl
Vue.prototype.$utils = utils
Vue.prototype.$signout = signout
import nomore from '@/components/nomore.vue'
Vue.component("nomore", nomore);//
Vue.prototype.$echarts = function (el) {
  return echarts.init(el, null, {renderer: 'svg'})
}
Vue.config.productionTip = false
Vue.use(vueResource)
Vue.use(ElementUI)
/* eslint-disable no-new */
Vue.filter('addurl', function(url) {    // msg 为固定的参数 即是你需要过滤的数据
  if(url){
    if(url.indexOf('http') == -1){
      var url = apiurl.api.baseurl + url;
    }
  }
  return url;
})
Vue.filter('time', function(value) {
	let date = new Date(value*1000);
	if (date) {
    let y = date.getFullYear();
    let MM = date.getMonth() + 1;
    MM = MM < 10 ? ('0' + MM) : MM;
    let d = date.getDate();
    d = d < 10 ? ('0' + d) : d;
    let h = date.getHours();
    h = h < 10 ? ('0' + h) : h;
    let m = date.getMinutes();
    m = m < 10 ? ('0' + m) : m;
    let s = date.getSeconds();
    s = s < 10 ? ('0' + s) : s;
    return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;

	}
	return url
})
Vue.prototype.ExportSavePdf = ({id,name,time: currentTime}) => {
  let element = document.getElementById(id)
  html2canvas(element,{
    logging: false,
    scale: 2,
    useCORS: true
  }),then((canvas) => {
    let pdf = new JSPDF("p", "mm", "a4") // A4纸，纵向
      let ctx = canvas.getContext("2d")
  })
}
// router.beforeEach((to, from, next) => {
//   //路由发生改变时,触发
//   window.document.title = to.meta.title == undefined ? '政策宝' : to.meta.title
//   // if (to.meta.requireAuth) {
//   //     let token = Cookies.get('access_token');
//   //     let anonymous = Cookies.get('user_name');
//   //     if (token) {
//   //          next({
//   //              path: '/login',
//   //              query: {
//   //                  redirect: to.fullPath
//   //              }
//   //          })
//   //     }
//   // }
//   next();
// })
var whiteList = ['/newindex','/login','/dataview','/page1','/page2','/page3','/page4','/matche','/comdetail','/companystack','/newcheck','/functions','/bulletin','/checkintest','/teamdetail','/test','/testword','/index','/bindphone','/','/search','/policylibrary','/companylist','/wisdom','/policyweb','/teamwork','/aboutus','/snotice','/snoticedetail','/scompany','/scompanytwo','/vector']
router.beforeEach((to, from, next) => {
  let token = localStorage.getItem('userid')
  // console.log(to.path)
  // console.log(whiteList)
  if(whiteList.indexOf(to.path) != -1){
    // console.log("白名单")
    next()
    return
  }


  // if(!token){
  //   // websocketRequest.closeWebSocket();
  //   next('/login');
  //   return
  // }
  //配置动态路由信息
  let newRouter = null;

  // if(store.getters.newRouter === newRouter)
    next()
  // else{
  //     router.addRoutes(newRouter) //添加动态路由
  //     store.dispatch('routerAction',newRouter).then(res => {
  //       next({ ...to })
  //     }).catch(() => {
  //     })
  // }
})
router.afterEach((to, from, next) =>{
  if(to.matched.length==0){
     router.push({
      path: "/"
    });
    return
  }
})


new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})




// WEBPACK FOOTER //
// ./src/main.js